import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ServiceGrid from './components/ServiceGrid';
import CoverageScroll from './components/CoverageScroll';
import Stats from './components/Stats';
import Testimonial from './components/Testimonial';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <ServiceGrid />
      <CoverageScroll />
      <Stats />
      <Testimonial />
      <CTA />
      <Footer />
    </main>
  );
}